import { render, staticRenderFns } from "./AppDialogTitle.vue?vue&type=template&id=36b3c9e1&scoped=true"
import script from "./AppDialogTitle.vue?vue&type=script&lang=js"
export * from "./AppDialogTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3c9e1",
  null
  
)

export default component.exports